import { Button, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import { confirmOrders, requestDeleteOrder } from '../../../requests/requests'
import { KTIcon } from '../../../../_metronic/helpers'
import { Link, useLocation } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { OrderStatus, PendingOrder } from '../../../models/models'
import { formatDate } from '../../../helpers/formatDate'
import { useNavigateHelper } from '../../../hooks/useNavigateHelper'
import { ConfirmDeleteModal } from '../../../components/generic-confirm/Confirm'
import { Dispatch, useState } from 'react'
import { useBtnTitles } from '../../../hooks/useBtnTitles'
import { IsFrozenProduct, IsMProduct, IsPieceProduct, IsSmallPieceProduct, IsVProduct } from '../../../helpers/utils'

export default function ValidateOrdersRow(
  {
    order,
    refetch,
    setOrdersSelection,
    validatingOrder,
    setValidatingOrder,
    validatingIndividualOrder,
    setValidatingIndividualOrder,
  }: {
    order: PendingOrder
    refetch: any
    setOrdersSelection: any
    validatingOrder: boolean
    setValidatingOrder: any
    validatingIndividualOrder: string
    setValidatingIndividualOrder: Dispatch<React.SetStateAction<string>>
  },
  key
) {
  const intl = useIntl()
  const btnTitles = useBtnTitles()
  const location = useLocation()
  const navigate = useNavigateHelper()
  const [deleteShow, setDeleteShow] = useState(false)

  const validateOrder = async () => {
    setValidatingIndividualOrder(order.guidId)
    const confirmedOrders = await confirmOrders([order.guidId])
    localStorage.setItem('ordersValidated', JSON.stringify(confirmedOrders.data))
    setValidatingIndividualOrder('')
    await refetch()
    navigate(location.pathname)
  }

  const handleConfirmDelete = async (orderId: string) => {
    await requestDeleteOrder(orderId)
    await refetch()
  }

  return (
    <tr key={key} data-id={order.guidId} id={`tableOrderRow${order.guidId}`}>
      <td>
        <div className='form-check form-check-sm form-check-custom form-check-solid'>
          {order.status === OrderStatus.Pending && (
            <input className='form-check-input' type='checkbox' onChange={setOrdersSelection} />
          )}
          <ConfirmDeleteModal
            show={deleteShow}
            onHide={() => setDeleteShow(false)}
            onConfirm={() => {
              handleConfirmDelete(order.guidId)
            }}
            title={intl.formatMessage({ id: 'CONFIRM_TEXT' })}
            message={intl.formatMessage({ id: 'BUTTON.CONFIRM_DELETE' })}
          />
        </div>
      </td>
      <td className='text-center'>
        <span className='text-dark fw-bold d-block fs-6'>
          {new Date(order.dateCreated).toLocaleDateString('en-GB')}
        </span>
      </td>
      <td className='text-center'>
        <span className='text-dark fw-bold d-block fs-6'>{`${order.customer?.businessName}`}</span>
        <span className='text-muted fw-semibold text-muted d-block fs-7'>
          {`${order.detail?.clientBusinessName}`}
        </span>
      </td>
      <td className='text-center'>
        <span className='text-dark fw-bold d-block fs-6'>
          {order.detail.shippingAddressDescription} ({order.detail.shippingAddressSageCode})
        </span>
      </td>
      <td className='text-center'>
        <span className='text-dark fw-bold d-block fs-6'>{formatDate(order.expeditionDate)}</span>
      </td>
      <td className='text-center'>
        <span
          className={`badge ${order.status === OrderStatus.Pending ? 'badge-light-warning' : 'badge-light-success'
            }`}
        >
          <span>
            {intl.formatMessage({ id: 'ORDER.STATUS.' + OrderStatus[order.status].toUpperCase() })}
          </span>
        </span>
      </td>
      <td className='text-center'>
        <Link
          to={`/order-detail/${order.guidId}`}
          className='d-inline-flex flex-items-center justify-content-center'
          title={btnTitles.details}
          onClick={() => {
            localStorage.setItem('lastOrderView', order.guidId)
          }}
        >
          <KTIcon iconName='eye' className='fs-3' />
        </Link>
        {order.status === OrderStatus.Pending && (
          <>
            <Link
              to={`/order-edit/${order.guidId}`}
              className='d-inline-flex flex-items-center justify-content-center ms-3'
              title={btnTitles.edit}
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </Link>
            <Link
              to={`#`}
              className='d-inline-flex flex-items-center justify-content-center ms-3'
              title={btnTitles.delete}
              onClick={() => setDeleteShow(true)}
            >
              <KTIcon iconName='trash' className='fs-3' />
            </Link>
          </>
        )}
        {order.status === OrderStatus.Pending &&
          order.sageResponse &&
          order.sageResponse.length > 0 && (
            <OverlayTrigger
              placement='top'
              overlay={
                <Tooltip>
                  <div>{order.sageResponse}</div>
                  {/* <div>
                {order.lines.map((item:Line, index: number) => (
                  <div className="d-flex flex-column" key={`order-validate-line-${order.id}-${index}`}>
                    <strong key={index}>{item.description}</strong>
                    <span>
                      {
                        `${item.stockUnit === 'KG' 
                        ? `${item.quantity} ${item.packageUnit} ${item.stockRatio} ${item.stockUnit}` 
                        : `${item.quantity} ${item.stockUnit} ${item.packageUnit}`}`
                      }        
                    </span>              
                  </div>
                ))}
              </div> */}
                </Tooltip>
              }
            >
              <span className='d-inline-flex flex-items-center justify-content-center ms-3'>
                <KTIcon iconName='information-4' className='fs-3 text-danger' iconType='solid' />
              </span>
            </OverlayTrigger>
          )}
        {order.warnings?.length > 0 && (
          <OverlayTrigger
            placement='top'
            trigger={['hover', 'focus']}
            overlay={
              <Tooltip id={`order-warnings-${order.guidId}`}>
                <div className='d-flex flex-column gap-2 text-start'>
                  {order.warnings.map((warning, index) => (
                    <div key={`${warning.code}-${index}`}>
                      {intl.formatMessage({
                        id: warning.code,
                        defaultMessage: warning.description,
                      })}
                    </div>
                  ))}
                </div>
              </Tooltip>
            }
          >
            <span
              className='d-inline-flex flex-items-center justify-content-center ms-3'
              tabIndex={0}
              aria-label={intl.formatMessage({ id: 'ORDERS.CREATE_NEW_ORDER_WARNINGS_TITLE' })}
            >
              <svg width='22' height='20' viewBox='0 0 22 20' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true' focusable='false'>
                <path fillRule='evenodd' clipRule='evenodd' d='M8.41304 1.3792C9.47048 -0.459735 12.1237 -0.459735 13.181 1.3792L21.224 15.3669C22.2782 17.2003 20.9548 19.4877 18.84 19.4877H2.75409C0.639295 19.4877 -0.68407 17.2003 0.370095 15.3669L8.41304 1.3792ZM10.7969 5.98731C11.2111 5.98731 11.5469 6.3231 11.5469 6.73731V10.7373C11.5469 11.1515 11.2111 11.4873 10.7969 11.4873C10.3827 11.4873 10.0469 11.1515 10.0469 10.7373V6.73731C10.0469 6.3231 10.3827 5.98731 10.7969 5.98731ZM11.3644 15.2381C11.6415 14.9302 11.6165 14.456 11.3086 14.1789C11.0007 13.9018 10.5265 13.9267 10.2494 14.2346L10.2394 14.2457C9.96228 14.5536 9.98727 15.0278 10.2952 15.3049C10.6031 15.582 11.0773 15.557 11.3544 15.2492L11.3644 15.2381Z' fill='#FFC700' />
              </svg>
            </span>
          </OverlayTrigger>
        )}
      </td>
      <td className='text-end'>
        {order.lines.find((x) => IsFrozenProduct(x.code)) && (
          <div
            className='d-inline-flex me-3'
            title={intl.formatMessage({ id: 'GENERAL.FROZEN_PRODUCT' })}
          >
            <i className='bi bi-snow2 text-primary'></i>
          </div>
        )}
        {order.lines.find((x) => IsSmallPieceProduct(x)) && (<div
          className='d-inline-flex me-3'
          title={intl.formatMessage({ id: 'GENERAL.SMALL_PIECE_PRODUCT' })}
        >
          <span>&lt;</span>
        </div>)
        }{order.lines.find((x) => IsPieceProduct(x.code)) && (<div
          className='d-inline-flex me-3'
          title={intl.formatMessage({ id: 'GENERAL.PIECE_PRODUCT' })}
        >
          <span>P</span>
        </div>)
        }
        {order.lines.some((line) => IsMProduct(line.code)) && (
          <div
            className='d-inline-flex me-3'
            title={intl.formatMessage({ id: 'GENERAL.M_PRODUCT' })}
          >
            <span>M</span>
          </div>
        )}
        {order.lines.some((line) => IsVProduct(line.code)) && (
          <div
            className='d-inline-flex me-3'
            title={intl.formatMessage({ id: 'GENERAL.V_PRODUCT' })}
          >
            <span>V</span>
          </div>
        )}
        {order.status === OrderStatus.Pending && (
          <Button
            className={`btn btn-primary ${validatingOrder ? 'disabled' : ''} ${validatingIndividualOrder.length > 0 ? 'disabled' : ''
              }`}
            onClick={validateOrder}
          >
            <div className='d-flex align-items-center justify-content-center'>
              {intl.formatMessage({ id: 'VALIDATE_ORDERS.ROW_VALIDATE' })}
              {validatingIndividualOrder === order.guidId && (
                <Spinner animation='border' className='mx-3'></Spinner>
              )}
              {validatingOrder && <Spinner animation='border' className='mx-3'></Spinner>}
            </div>
          </Button>
        )}
      </td>
    </tr>
  )
}
